import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layout/preloader/preloader.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { SubscribeComponent } from './components/common/subscribe/subscribe.component';

import { HomeComponent } from './components/website/home/home.component';
import { FunfactComponent } from './components/website/funfact/funfact.component';
import { FeedbackComponent } from './components/website/feedback/feedback.component';
import { AboutComponent } from './components/website/about/about.component';
import { OffGridSolarComponent } from './components/website/off-grid-solar/off-grid-solar.component';
import { OnGridSolarComponent } from './components/website/on-grid-solar/on-grid-solar.component';
import { HybridSolarComponent } from './components/website/hybrid-solar/hybrid-solar.component';
import { FloatingWhatsappComponent } from './components/website/floating-whatsapp/floating-whatsapp.component';
import { SolarCalculatorComponent } from './components/website/solar-calculator/solar-calculator.component';
import { FormsModule } from '@angular/forms';
import { SolarSubsidyComponent } from './components/website/solar-subsidy/solar-subsidy.component';
import { FaqComponent } from './components/website/faq/faq.component';
import { BlogDetailComponent } from './components/website/blog-detail/blog-detail.component';
import { BlogComponent } from './components/website/blog/blog.component';
import { PrivacyPolicyComponent } from './components/website/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './components/website/terms-conditions/terms-conditions.component';
import { ReferAndEarnComponent } from './components/website/refer-and-earn/refer-and-earn.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    FunfactComponent,
    FeedbackComponent,
    SubscribeComponent,
    AboutComponent,
    BlogComponent,
    FaqComponent,
    OffGridSolarComponent,
    OnGridSolarComponent,
    HybridSolarComponent,
    FloatingWhatsappComponent,
    SolarCalculatorComponent,
    SolarSubsidyComponent,
    BlogDetailComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    ReferAndEarnComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
